import React from 'react';
import HeaderImage from "../assets/bank-assets/header.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Eligibility(props) {

    const { t, i18n } = useTranslation();


    return (
        <>
            {i18n.language === "fr" ? (
                <div className="flex flex-col items-center w-screen ">
                    <div className="justify-center my-10 px-4">
                        <h2 className="text-3xl  text-primary-color text-center mb-10 font-semibold">
                            Critères d’Eligibilité
                        </h2>
                        <img alt={"..."} className="w-128 rounded-2xl" src={HeaderImage} />
                    </div>
                    <div className="justify-center my-10">
                        <div className="items-center mx-8 lg:mx-2 text-left max-w-3xl">
                            <h6 className="text-lg font-meduim  mb-5 font-meduim">
                                Le financement <span className="font-bold">« Mourabaha Biens à la Consommation »</span> est
                                destiné aux Particuliers devant répondre aux critères d’éligibilité suivants :

                            </h6>
                            <ul className="list-disc ml-4">
                                <li>Etre de Nationalité Algérienne et Résident en Algérie</li>
                                <li>Avoir un revenu permanent et régulier au moins égal à une fois et demi (1,5) au salaire
                                    national minimum garanti, pour les salariés et retraités
                                </li>
                                <li>Avoir au moins une année d’activité au moment de l’octroi du financement « Mourabaha
                                    Biens à
                                    la Consommation », pour les salariés
                                </li>
                                <li> Avoir au moins trois (03) années d’activité successives, lors de la demande du
                                    financement
                                    « Mourabaha Biens à la Consommation », pour les Travailleurs exerçant à titre temporaire
                                </li>
                                <li>Avoir un revenu mensuel supérieur ou égal à une fois et demie (1,5) le salaire national
                                    minimum garanti, pour les personnes exerçant des professions libérales et commerçantes
                                </li>
                                <li>Etre âgé de 70 ans au maximum à la date du dépôt de la demande de financement</li>
                                <li>Disposer du gage du sérieux « Hamich al Djidiya »</li>

                            </ul>
                        </div>
                    </div>
                    <section>
                        <div className="relative items-center w-full px-5 py-12 mx-auto md:px-12 lg:px-24 max-w-7xl">
                            <div className="p-6 border-l-4 border-blue-500 rounded-r-xl bg-blue-50">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <svg className="w-5 h-5 text-blue-600" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                    <div className="ml-3">
                                        <div className="text-md text-blue-600">
                                            <p><span className="font-bold">NB:</span> Ce Financement est destiné pour toute
                                                Personne Physique qui, pour l’acquisition d’un bien à la consommation,<span
                                                    className="font-bold"> agit dans un but privé en dehors de ses activités commerciales, professionnelles ou artisanales.</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            ) : (
                <div className="flex flex-col items-center w-screen ">
                    <div className="justify-center my-10 px-4">
                        <h2 className="text-3xl text-primary-color text-center mb-10 font-semibold">
                            معايير الأهلية
                        </h2>
                        <img alt={"..."} className="w-128 rounded-2xl" src={HeaderImage} />
                    </div>
                    <div className="justify-center my-10">
                        <div className="items-center text-right max-w-3xl">
                            <h6 className="text-lg  font-meduim mb-5 font-meduim">
                                :  مخصص للأفراد الذين يجب أن يستوفوا معايير الأهلية التالية<span className="font-bold"> "e-faciliti"  </span> تمويل

                            </h6>
                            <ul className="mr-4">
                                <li> أن يكون جزائري الجنسية ومقيم في الجزائر ○</li>
                                <li>أن يكون لديه دخل دائم ومنتظم يعادل على الأقل مرة ونصف (1.5) الحد الأدنى المضمون للأجور الوطنية للموظفين والمتقاعدين ○</li>
                                <li> للموظفين " e-faciliti "  أن يكون لديه نشاط لمدة عام على الأقل وقت منح تمويل ○</li>
                                <li>للعمال الذين يعملون على أساس توظيف مؤقت " e-faciliti " أن يكون لديه ما لا يقل عن ثلاث (03) سنوات من النشاط المتتالي، عند التقدم للحصول على تمويل ○</li>
                                <li>الحصول على دخل شهري أكبر من أو يساوي مرة ونصف (1.5) ضعف الحد الأدنى للأجر الوطني المضمون، للأشخاص الذين يمارسون المهن الحرة والتجارية ○</li>
                                <li>أن تبلغ من العمر 70 عامًا على الأكثر في تاريخ تقديم طلب التمويل ○</li>
                                <li>الضمان "هامش الجدية" ○</li>

                            </ul>
                        </div>
                    </div>
                    <section className="">
                        <div className="relative items-center w-full px-5 py-12 mx-auto md:px-12 lg:px-24 max-w-7xl">
                            <div className="p-6 border-r-4 border-blue-500 rounded-l-xl bg-blue-50">
                                <div className="flex">
                                    <div className="ml-3">
                                        <div className="text-md text-blue-600">
                                            <p><span className="font-bold"> ملاحظة :</span> هذا التمويل مخصص لأي شخص طبيعي يعمل لغرض خاص لاقتناء سلعة استهلاكية خارج أنشطته التجارية أو المهنية أو الحرفية.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="flex-shrink-0">
                                        <svg className="w-5 h-5 text-blue-600" xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                            <path fill-rule="evenodd"
                                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                                clip-rule="evenodd"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            )}

        </>
    );
}

export default Eligibility;